import { Button } from "@/components/ui/button";
import { useLocation } from "react-router-dom";

export default function Login() {
  const location = useLocation();
  const err = location.state?.error;

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 px-4">
      <div className="w-full max-w-md bg-white border-2 border-slate-300 p-6 md:p-8 rounded-sm">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-12 w-12 bg-slate-900 text-white grid place-items-center font-bold text-xl rounded-sm">V</div>
          <div>
            <div className="text-xl font-bold text-slate-900 leading-none">VAS POS 2</div>
            <div className="text-xs text-slate-600 mt-1">Velkar Auto Service · Thane</div>
          </div>
        </div>
        <h1 className="text-2xl font-bold tracking-tight text-slate-900">Sign in</h1>
        <p className="text-sm text-slate-600 mt-2">Use your work Google account. New users are added by the admin.</p>

        {err && (
          <div data-testid="login-error" className="mt-4 p-3 border border-red-300 bg-red-50 text-red-800 text-sm rounded-sm">
            {err}
          </div>
        )}

        <Button
          data-testid="google-sign-in-btn"
          onClick={handleLogin}
          className="mt-6 w-full h-12 bg-slate-900 hover:bg-slate-800 text-white font-semibold text-base"
        >
          Continue with Google
        </Button>

        <div className="mt-8 pt-6 border-t border-slate-200 text-xs text-slate-500">
          Shift Codes: 3-shift (SC-01/02/03) or 2-shift (SC-D/N). Timezone: Asia/Kolkata. Currency: INR ₹.
        </div>
      </div>
    </div>
  );
}
